import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Sparkles, TrendingUp, Shield, Zap } from 'lucide-react';
import '../../../assets/styles/customer/layout/PricingHeroSection.css';

const PricingHeroSection = () => {
  return (
    <section className="pricing-hero-section">
      
      {/* Floating Background Elements */}
      <div className="pricing-hero-floating">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
      </div>

      {/* Decorative Icons */}
      <div className="pricing-hero-icons">
        <div className="icon-float icon-1">
          <TrendingUp size={32} strokeWidth={1.5} />
        </div>
        <div className="icon-float icon-2">
          <Shield size={28} strokeWidth={1.5} />
        </div>
        <div className="icon-float icon-3">
          <Zap size={30} strokeWidth={1.5} />
        </div>
      </div>

      {/* Wavy Background */}
      <div className="pricing-hero-wave">
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(62, 150, 231, 0.05)" 
            d="M0,96L48,112C96,128,192,160,288,165.3C384,171,480,149,576,133.3C672,117,768,107,864,112C960,117,1056,139,1152,138.7C1248,139,1344,117,1392,106.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>

      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            
            <div className="pricing-hero-content">
              
              {/* Badge */}
              <div className="pricing-hero-badge">
                <Sparkles size={18} />
                <span>Simple & Transparent Pricing</span>
              </div>

              {/* Main Heading */}
              <h1 className="pricing-hero-title">
                Start Free, <span className="pricing-hero-highlight">Scale as You Grow</span>
              </h1>

              {/* Description */}
              <p className="pricing-hero-description">
                No hidden fees, no surprises. Choose the plan that fits your business.
              </p>

              {/* Trust Indicators */}
              <div className="pricing-hero-trust">
                <div className="trust-item">
                  <div className="trust-icon">
                    <Shield size={20} />
                  </div>
                  <span>No Credit Card Required</span>
                </div>
                <div className="trust-divider"></div>
                <div className="trust-item">
                  <div className="trust-icon">
                    <Zap size={20} />
                  </div>
                  <span>Cancel Anytime</span>
                </div>
                <div className="trust-divider"></div>
                <div className="trust-item">
                  <div className="trust-icon">
                    <TrendingUp size={20} />
                  </div>
                  <span>30-Day Money Back</span>
                </div>
              </div>

            </div>

          </Col>
        </Row>
      </Container>

    </section>
  );
};

export default PricingHeroSection;